import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  Grid,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  getTruncateCart,
  getTruncateContactus,
  getTruncateDataCounts,
  getTruncateOrders,
  getTruncateReviews,
  getTruncateUsers,
  getTruncateWishlist,
} from "services/apiService";
import Swal from "sweetalert2";
import loadingImage from "../../assect/loadingSvg/loading.svg";

interface DruncateData {
  name: string;
  count: number;
}
const Truncate = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [truncateData, setTruncateData] = useState([]);
  useEffect(() => {
    fetchTruncateData();
  }, []);
  const fetchTruncateData = async () => {
    setIsLoading(true);
    try {
      const resposne = await getTruncateDataCounts();
      setTruncateData(resposne?.data);
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const fetchTruncateCart = async () => {
    try {
      const resposne = await getTruncateCart();
      return resposne;
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
    } finally {
    }
  };
  const fetchTruncateWishlist = async () => {
    try {
      const resposne = await getTruncateWishlist();
      return resposne;
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
    } finally {
    }
  };
  const fetchTruncateUsers = async () => {
    try {
      const resposne = await getTruncateUsers();
      return resposne;
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
    } finally {
    }
  };
  const fetchTruncateOrders = async () => {
    try {
      const resposne = await getTruncateOrders();
      return resposne;
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
    } finally {
    }
  };
  const fetchTruncateContactUs = async () => {
    try {
      const resposne = await getTruncateContactus();
      return resposne;
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
    } finally {
    }
  };
  const fetchTruncateReviews = async () => {
    try {
      const resposne = await getTruncateReviews();
      return resposne;
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
    } finally {
    }
  };
  function apiFlag(name: String) {
    if (name === "User Carts") {
      return fetchTruncateCart();
    } else if (name === "User WishList Count") {
      return fetchTruncateWishlist();
    } else if (name === "Users ") {
      return fetchTruncateUsers();
    } else if (name === "Orders") {
      return fetchTruncateOrders();
    } else if (name === "User Contact Us") {
      return fetchTruncateContactUs();
    } else if (name === "User Review Count") {
      return fetchTruncateReviews();
    }
  }
  const handleDelete = async (data: DruncateData) => {
    try {
      const firstConfirmation = await Swal.fire({
        title: "Are you sure?",
        html: `You wanted to delete <strong style="color: orange; padding: 3px;">⚠️ ${data?.name}</strong>`,
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "Cancel",
      });
      if (firstConfirmation.isConfirmed) {
        const secondConfirmation = await Swal.fire({
          title: "Are you really sure?",
          text: "This action cannot be undone!",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Yes, I am sure!",
          cancelButtonText: "Cancel",
        });

        if (secondConfirmation.isConfirmed) {
          const response: any = await apiFlag(data?.name);
          if (response.status_code === 200) {
            fetchTruncateData();
            Swal.fire("Deleted!", "The Tax has been deleted.", "success");
          } else {
            Swal.fire("Error!", "Something went wrong!", "error");
          }
        } else {
          Swal.fire("Cancelled", "", "info");
        }
      }
    } catch (error) {
      Swal.fire("Error!", "An unexpected error occurred.", "error");
    }
  };

  return (
    <>
      {isLoading ? (
        <div className="loadingsvg-Image text-center">
          <img src={loadingImage} width={80} height={80} alt="Loading..." />
        </div>
      ) : truncateData?.length > 0 ? (
        <Grid container spacing={4}>
          {truncateData?.length > 0 &&
            truncateData?.map((x) => {
              return (
                <Grid item lg={3} md={6} sm={8}>
                  <Card
                    sx={{
                      minWidth: 275,
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                      transition: "box-shadow 0.3s ease-in-out",
                      "&:hover": {
                        boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
                      },
                    }}
                  >
                    <CardContent sx={{ minHeight: 200, textAlign: "center" }}>
                      <Typography
                        gutterBottom
                        sx={{ fontSize: 20, fontWeight: 700 }}
                      >
                        {x?.name}
                      </Typography>
                      <Typography gutterBottom sx={{ fontSize: 54 }}>
                        {x?.count}
                      </Typography>
                    </CardContent>
                    <CardActions>
                      <Button
                        size="small"
                        variant="contained"
                        sx={{
                          fontWeight: 700,
                          py: 1,
                          "&:hover": {
                            backgroundColor: "transparent",
                            color: "red",
                            border: "1px solid",
                            borderColor: "error.main",
                          },
                        }}
                        fullWidth
                        startIcon={<FontAwesomeIcon icon={faTrash} />}
                        onClick={() => handleDelete(x)}
                      >
                        Truncate
                      </Button>
                    </CardActions>
                  </Card>
                </Grid>
              );
            })}
        </Grid>
      ) : (
        <Typography
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "50vh",
          }}
        >
          No Data Available
        </Typography>
      )}
    </>
  );
};

export default Truncate;
